var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"dark":""}},[_c('highlight',{staticClass:"code--custom",attrs:{"language":_vm.language}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }